"use strict";

var _defineProperty = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/defineProperty.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactPortableText = _interopRequireDefault(require("react-portable-text"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _typoUC, _text;

  return {
    typo: _defineProperty({
      color: 'white',
      textAlign: 'center',
      margin: '.75rem 0'
    }, theme.breakpoints.down('xs'), {
      textAlign: 'left',
      lineHeight: 0.6
    }),
    typoUC: (_typoUC = {
      color: 'white',
      textAlign: 'center',
      margin: '1rem 0',
      fontSize: '1.7rem'
    }, _defineProperty(_typoUC, theme.breakpoints.down('md'), {
      fontSize: '1.4rem'
    }), _defineProperty(_typoUC, theme.breakpoints.down('xs'), {
      textAlign: 'left',
      lineHeight: 0.6,
      fontSize: '1.25rem'
    }), _typoUC),
    text: (_text = {
      textAlign: 'center',
      color: 'white',
      fontWeight: 425
    }, _defineProperty(_text, theme.breakpoints.down('md'), {
      marginLeft: '0'
    }), _defineProperty(_text, theme.breakpoints.down('sm'), {
      // marginLeft: '4rem',
      lineHeight: '1.2',
      maxWidth: '590px'
    }), _defineProperty(_text, theme.breakpoints.down('xs'), {
      marginLeft: '0',
      textAlign: 'left',
      fontSize: '1rem'
    }), _text)
  };
});

var PromotionBar = function PromotionBar(_ref) {
  var barColor = _ref.barColor,
      ucText = _ref.ucText,
      promotion = _ref.promotion,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? true : _ref$open,
      setOpen = _ref.setOpen;
  var classes = useStyles();
  var theme = (0, _core.useTheme)();
  return /*#__PURE__*/_react.default.createElement(_core.Collapse, {
    in: open
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    direction: "row",
    justifyContent: "center",
    alignItems: "center",
    style: {
      background: barColor !== null && barColor !== void 0 ? barColor : theme.workwaveBlue
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Container, {
    fixed: true
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6",
    className: ucText ? classes.typoUC : classes.typo
  }, /*#__PURE__*/_react.default.createElement(_reactPortableText.default, {
    content: promotion._rawContent,
    serializers: {
      normal: function normal(_ref2) {
        var children = _ref2.children;
        return /*#__PURE__*/_react.default.createElement("span", null, children);
      },
      link: function link(_ref3) {
        var blank = _ref3.blank,
            children = _ref3.children,
            href = _ref3.href;
        return /*#__PURE__*/_react.default.createElement("a", {
          href: href,
          target: "_blank",
          rel: "noopener noreferrer",
          "aria-label": "Opens in a new tab",
          className: classes.text,
          style: {
            marginLeft: 'none',
            fontWeight: 700,
            textDecoration: '0'
          }
        }, children);
      }
    }
  }))), /*#__PURE__*/_react.default.createElement(_Close.default, {
    style: {
      cursor: 'pointer',
      color: 'white',
      position: 'relative',
      marginRight: '1rem'
    },
    onClick: function onClick(e) {
      return setOpen(false);
    }
  }))));
};

var _default = PromotionBar;
exports.default = _default;